var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/quickshop-actions/quickshop-remove-link.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isCompletlyFufilled")?"u-link--disabled is-disabled":"");
frame.set("disabledClass", t_1, true);
if(frame.topLevel) {
context.setVariable("disabledClass", t_1);
}
if(frame.topLevel) {
context.addExport("disabledClass", t_1);
}
output += "\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isPartiallyFufilled")) {
output += "\n\n    ";
var t_2;
t_2 = "js-remove-unfulfilled-from-cart";
frame.set("jsClass", t_2, true);
if(frame.topLevel) {
context.setVariable("jsClass", t_2);
}
if(frame.topLevel) {
context.addExport("jsClass", t_2);
}
output += "\n\n";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isCompletlyFufilled")) {
output += "\n\n    ";
var t_3;
t_3 = "";
frame.set("jsClass", t_3, true);
if(frame.topLevel) {
context.setVariable("jsClass", t_3);
}
if(frame.topLevel) {
context.addExport("jsClass", t_3);
}
output += "\n\n";
;
}
else {
output += "\n\n    ";
var t_4;
t_4 = "js-remove-from-cart";
frame.set("jsClass", t_4, true);
if(frame.topLevel) {
context.setVariable("jsClass", t_4);
}
if(frame.topLevel) {
context.addExport("jsClass", t_4);
}
output += "\n\n";
;
}
;
}
output += "\n\n<li class=\"c-product-add-links__li c-product-remove__li  dom-remove-from-cart\">\n\n    <a href=\"#\" class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsClass"), env.opts.autoescape);
output += " c-product-add-links__a c-product-remove-from-cart__a ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabledClass"), env.opts.autoescape);
output += "\" data-qa-remove-from-cart>\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"source") == "wishlist") {
output += "\n\n            ";
output += runtime.suppressValue((lineno = 22, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-remove-from-wishlist"])), env.opts.autoescape);
output += "\n\n        ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"source") == "registry") {
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isPartiallyFufilled")) {
output += "\n\n                ";
output += runtime.suppressValue((lineno = 28, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_remove_outstanding_items"])), env.opts.autoescape);
output += "\n\n            ";
;
}
else {
output += "\n\n                ";
output += runtime.suppressValue((lineno = 32, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-remove-from-registry"])), env.opts.autoescape);
output += "\n\n            ";
;
}
output += "\n\n        ";
;
}
;
}
output += "\n\n    </a>\n\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/quickshop-actions/quickshop-remove-link.j2"] , dependencies)